import React from "react";


import {
    ReactSVG
} from "react-svg";


type SvgIconComponentProps = {
    iconSource: string;
    className?: string;
    onClick?: () => void;
};


export const SvgIconComponent:React.FC<SvgIconComponentProps> = ({
    iconSource, className, onClick
}) => {

    if (!iconSource) {
        return null;
    }

    return (
        <ReactSVG
            src={iconSource} wrapper={'span'} className={className}
            onClick={onClick}
        />
    );
};


export default SvgIconComponent;
